import React from "react";
import { useParams } from "react-router-dom";
import { PersonOrgForm } from "common/components/PersonOrgForm";
import { grey } from "@mui/material/colors";
import Heading from "common/components/Heading";

const EditSupplier = () => {
  const { supplierId } = useParams();
  return (
    <div>
      <div>
        <div>
          <Heading
            variant={"h3"}
            title={"Edit Vendor"}
            sxProp={{ fontWeight: 800, m: 2, p: 2, color: grey[600] }}
          />
        </div>
        <PersonOrgForm id={supplierId} formName="supplier" />
      </div>
    </div>
  );
};

export default EditSupplier;
